import Vue from 'vue';

Vue.directive('autoclick', {
  inserted(el, { value }) {
    value && el.click && el.click();
  }
});
